<div class="merge-history-container" style="position:relative;">
  <!-- Loading overlay spinner -->
  <div *ngIf="loading" class="merge-history-loading-overlay">
    <p-progressSpinner></p-progressSpinner>
  </div>

  <div class="merge-history-tabs">
    <p-tabView [(activeIndex)]="activeTab" (activeIndexChange)="onTabChange($event)">
      <div class="repo-filters merge-filters">
        <div class="filters-group">
          <!-- From Branch Filter (shown on first tab) -->
          <p-floatlabel variant="on" *ngIf="activeTab === 0">
            <p-multiSelect
              inputId="from-branch-filter"
              [options]="fromBranchOptions"
              [(ngModel)]="selectedFromBranches"
              [showClear]="true"
              (onChange)="onFilterChange()"
              (onClear)="onFilterChange()"
              [resetFilterOnHide]="true"
              appendTo="body"
            >
              <ng-template pTemplate="selectedItems" let-items>
                @if (items?.length > 0) {
                  <span class="selected-item-text">{{ items[0] }}</span>
                  @if (items.length > 1) {
                    <span class="selected-count">+{{ items.length - 1 }}</span>
                  }
                }
              </ng-template>
            </p-multiSelect>
            <label for="from-branch-filter">{{ 'FROM_BRANCH' | translate }}</label>
          </p-floatlabel>
          <!-- To Branch Filter (shown on second tab) -->
          <p-floatlabel variant="on" *ngIf="activeTab === 1">
            <p-multiSelect
              inputId="to-branch-filter"
              [options]="toBranchOptions"
              [(ngModel)]="selectedToBranches"
              [showClear]="true"
              (onChange)="onFilterChange()"
              (onClear)="onFilterChange()"
              [resetFilterOnHide]="true"
              appendTo="body"
            >
              <ng-template pTemplate="selectedItems" let-items>
                @if (items?.length > 0) {
                  <span class="selected-item-text">{{ items[0] }}</span>
                  @if (items.length > 1) {
                    <span class="selected-count">+{{ items.length - 1 }}</span>
                  }
                }
              </ng-template>
            </p-multiSelect>
            <label for="to-branch-filter">{{ 'TO_BRANCH' | translate }}</label>
          </p-floatlabel>
          <!-- From Date Filter -->
          <p-floatlabel variant="on">
            <p-datepicker
              inputId="start-date"
              [(ngModel)]="startDate"
              (onClose)="onDateFilterChange()"
              (onClear)="onDateFilterChange()"
              [dateFormat]="datePickerFormat"
              [showTime]="true"
              [hourFormat]="hourFormat"
              [stepHour]="1"
              [stepMinute]="1"
              [showClear]="!!startDate"
              appendTo="body"
              [showIcon]="true"
              iconDisplay="input"
              [maxDate]="endDate"
            ></p-datepicker>
            <label for="start-date">{{ 'FROM_DATE' | translate }}</label>
          </p-floatlabel>

          <!-- To Date Filter -->
          <p-floatlabel variant="on">
            <p-datepicker
              inputId="end-date"
              [(ngModel)]="endDate"
              (onClose)="onDateFilterChange()"
              (onClear)="onDateFilterChange()"
              [dateFormat]="datePickerFormat"
              [showTime]="true"
              [hourFormat]="hourFormat"
              [stepHour]="1"
              [stepMinute]="1"
              [showClear]="!!endDate"
              appendTo="body"
              [showIcon]="true"
              iconDisplay="input"
              [minDate]="startDate"
            ></p-datepicker>
            <label for="end-date">{{ 'TO_DATE' | translate }}</label>
          </p-floatlabel>
          <!-- Merged By Filter -->
          <p-floatlabel variant="on">
            <p-multiSelect
              inputId="merged-by-filter"
              [options]="mergedByOptions"
              [(ngModel)]="selectedMergedBy"
              [showClear]="true"
              (onChange)="onFilterChange()"
              (onClear)="onFilterChange()"
              [resetFilterOnHide]="true"
              appendTo="body"
            >
              <ng-template pTemplate="selectedItems" let-items>
                @if (items?.length > 0) {
                  <span class="selected-item-text">{{ getOptionLabel(mergedByOptions, items[0]) }}</span>
                  @if (items.length > 1) {
                    <span class="selected-count">+{{ items.length - 1 }}</span>
                  }
                }
              </ng-template>
            </p-multiSelect>
            <label for="merged-by-filter">{{ 'MERGED_BY' | translate }}</label>
          </p-floatlabel>
          <!-- Status Filter -->
          <p-floatlabel variant="on">
            <p-multiSelect
              inputId="status-filter"
              [options]="statusOptions"
              [(ngModel)]="selectedStatuses"
              [showClear]="true"
              (onChange)="onFilterChange()"
              (onClear)="onFilterChange()"
              [resetFilterOnHide]="true"
              appendTo="body"
            >
              <ng-template pTemplate="selectedItems" let-items>
                @if (items?.length > 0) {
                  <span class="selected-item-text">{{ getStatusDisplay(items[0]) }}</span>
                  @if (items.length > 1) {
                    <span class="selected-count">+{{ items.length - 1 }}</span>
                  }
                }
              </ng-template>
            </p-multiSelect>
            <label for="status-filter">{{ 'STATUS' | translate }}</label>
          </p-floatlabel>
          <button
            *ngIf="hasActiveFilters"
            pButton
            type="button"
            [label]="'CLEAR_FILTERS' | translate"
            class="p-button-outlined p-button-sm clear-all-btn"
            (click)="clearFilters()"
          ></button>
        </div>
      </div>
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span class="tab-header-content">
            <svg-icon src="assets/images/svg/merge-incoming.svg" class="tab-merge-icon"></svg-icon>
            {{ 'INCOMING_MERGES' | translate }}
            <span class="tab-count">{{ fromOtherBranchesTotal }}</span>
          </span>
        </ng-template>
        <div #incomingTableContainer class="table-scroll-wrapper">
        <p-table [value]="visibleMergesFromOther" styleClass="merge-table" [scrollable]="true" scrollHeight="flex">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col" (click)="setSort('sourceBranchName')" (keydown.enter)="setSort('sourceBranchName')">{{ 'FROM_BRANCH' | translate }}
                <span *ngIf="sortField === 'sourceBranchName'">
                  <i class="pi" [ngClass]="{'pi-sort-amount-up-alt': sortOrder === 'asc', 'pi-sort-amount-down': sortOrder === 'desc'}"></i>
                </span>
              </th>
              <th scope="col" (click)="setSort('mergedDate')" (keydown.enter)="setSort('mergedDate')">{{ 'MERGED_DATE' | translate }}
                <span *ngIf="sortField === 'mergedDate'">
                  <i class="pi" [ngClass]="{'pi-sort-amount-up-alt': sortOrder === 'asc', 'pi-sort-amount-down': sortOrder === 'desc'}"></i>
                </span>
              </th>
              <th scope="col">{{ 'MERGED_BY' | translate }}</th>
              <th scope="col" (click)="setSort('status')" (keydown.enter)="setSort('status')">{{ 'STATUS' | translate }}
                <span *ngIf="sortField === 'status'">
                  <i class="pi" [ngClass]="{'pi-sort-amount-up-alt': sortOrder === 'asc', 'pi-sort-amount-down': sortOrder === 'desc'}"></i>
                </span>
              </th>
              <th scope="col"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr>
              <td>{{ rowData.sourceBranchName }}</td>
              <td>{{ rowData.mergedDate | date:dateFormat }}</td>
              <td class="created-by-cell" [pTooltip]="rowData.modifiedBy" tooltipPosition="top">
                  <ng-container *ngIf="rowData.modifiedBy">
                    <p-avatar
                      [label]="rowData.modifiedBy[0].toUpperCase()"
                      shape="circle"
                      [style]="{ 'background-color': getBgColor(rowData.modifiedBy) }"
                      size="small"
                      styleClass="created-by-avatar avatar-text-color"
                    ></p-avatar>
                    <span class="created-by-name">
                      {{ rowData.modifiedBy }}
                    </span>
                  </ng-container>
                </td>
              <td>
                <span class="status-badge" [ngClass]="getStatusClass(rowData.status)" [pTooltip]="getStatusDisplay(rowData.status)" tooltipPosition="top">
                  {{ getStatusDisplay(rowData.status) }}
                </span>
              </td>
              <td>
                <a href="javascript:void(0)" class="highlight-link" (click)="viewComponents(rowData)">
                  {{ 'SHOW_COMPONENTS' | translate }}
                </a>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="no-records">
              <td colspan="6" class="text-center">
                <div *ngIf="loading" class="loading-container">
                  <p-progressSpinner></p-progressSpinner>
                </div>
                <span *ngIf="!loading">{{ 'NO_MERGES_FROM_OTHER_BRANCHES' | translate }}</span>
              </td>
            </tr>
          </ng-template>
        </p-table>
        </div>
      </p-tabPanel>
      <p-tabPanel>
        <ng-template pTemplate="header">
          <span class="tab-header-content">
            <svg-icon src="assets/images/svg/merge-outgoing.svg" class="tab-merge-icon"></svg-icon>
            {{ 'OUTGOING_MERGES' | translate }}
            <span class="tab-count">{{ fromThisBranchTotal }}</span>
          </span>
        </ng-template>
        <div #outgoingTableContainer class="table-scroll-wrapper">
        <p-table [value]="visibleMergesFromThis" styleClass="merge-table" [scrollable]="true" scrollHeight="flex">
          <ng-template pTemplate="header">
            <tr>
              <th scope="col" (click)="setSort('targetBranchName')" (keydown.enter)="setSort('targetBranchName')">{{ 'TO_BRANCH' | translate }}
                <span *ngIf="sortField === 'targetBranchName'">
                  <i class="pi" [ngClass]="{'pi-sort-amount-up-alt': sortOrder === 'asc', 'pi-sort-amount-down': sortOrder === 'desc'}"></i>
                </span>
              </th>
              <th scope="col" (click)="setSort('mergedDate')" (keydown.enter)="setSort('mergedDate')">{{ 'MERGED_DATE' | translate }}
                <span *ngIf="sortField === 'mergedDate'">
                  <i class="pi" [ngClass]="{'pi-sort-amount-up-alt': sortOrder === 'asc', 'pi-sort-amount-down': sortOrder === 'desc'}"></i>
                </span>
              </th>
              <th scope="col">{{ 'MERGED_BY' | translate }}</th>
              <th scope="col" (click)="setSort('status')" (keydown.enter)="setSort('status')">{{ 'STATUS' | translate }}
                <span *ngIf="sortField === 'status'">
                  <i class="pi" [ngClass]="{'pi-sort-amount-up-alt': sortOrder === 'asc', 'pi-sort-amount-down': sortOrder === 'desc'}"></i>
                </span>
              </th>
              <th scope="col"></th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-rowData>
            <tr>
              <td>{{ rowData.targetBranchName }}</td>
              <td>{{ rowData.mergedDate | date:dateFormat }}</td>
              <td class="created-by-cell" [pTooltip]="rowData.modifiedBy" tooltipPosition="top">
                  <ng-container *ngIf="rowData.modifiedBy">
                    <p-avatar
                      [label]="rowData.modifiedBy[0].toUpperCase()"
                      shape="circle"
                      [style]="{ 'background-color': getBgColor(rowData.modifiedBy) }"
                      size="small"
                      styleClass="created-by-avatar avatar-text-color"
                    ></p-avatar>
                    <span class="created-by-name">
                      {{ rowData.modifiedBy }}
                    </span>
                  </ng-container>
              </td>
              <td>
                <span class="status-badge" [ngClass]="getStatusClass(rowData.status)" [pTooltip]="getStatusDisplay(rowData.status)" tooltipPosition="top">
                  {{ getStatusDisplay(rowData.status) }}
                </span>
              </td>
              <td>
                <a href="javascript:void(0)" class="highlight-link" (click)="viewComponents(rowData)">
                  {{ 'SHOW_COMPONENTS' | translate }}
                </a>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <tr class="no-records">
              <td colspan="6" class="text-center">
                <div *ngIf="loading" class="loading-container">
                  <p-progressSpinner></p-progressSpinner>
                </div>
                <span *ngIf="!loading">{{ 'NO_MERGES_TO_OTHER_BRANCHES' | translate }}</span>
              </td>
            </tr>
          </ng-template>
        </p-table>
        </div>
      </p-tabPanel>
      
    </p-tabView>

  </div>

  <p-dialog
    [(visible)]="showComponentsDialog"
    [modal]="true"
    [closable]="true"
    [dismissableMask]="false"
    [styleClass]="'merge-components-dialog'"
    [baseZIndex]="10002"
    [draggable]="false"
    appendTo="body"
    (onHide)="showComponentsDialog = false"
  >
    <ng-template pTemplate="header">
      <span class="dialog-header">
        {{ 'MERGED_COMPONENTS' | translate }}
      </span>
    </ng-template>

    <p-table [value]="mergedComponents" [scrollable]="true" scrollHeight="flex" styleClass="merge-table">
      <ng-template pTemplate="header">
        <tr>
          <th *ngIf="isSuiteMode" scope="col">{{ 'APPLICATION' | translate }}</th>
          <th scope="col">{{ 'COMPONENT_TYPE' | translate }}</th>
          <th scope="col">{{ 'COMPONENT_NAME' | translate }}</th>
          <th scope="col">{{ 'ACTION' | translate }}</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData>
        <tr>
          <td *ngIf="isSuiteMode">{{ rowData.appName }}</td>
          <td>{{ rowData.type }}</td>
          <td>{{ rowData.name }}</td>
          <td> 
              {{ (rowData.action) }}
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr class="no-records">
          <td [attr.colspan]="isSuiteMode ? 4 : 3" class="text-center">
            <div *ngIf="dialogLoading" class="loading-container">
              <p-progressSpinner></p-progressSpinner>
            </div>
            <span *ngIf="!dialogLoading">{{ 'NO_MERGED_COMPONENTS' | translate }}</span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-dialog>
</div>
